import {Box} from '@chakra-ui/react';
import {PropsWithChildren} from 'react';

export const AppAlertDescription = (props: PropsWithChildren) => {
  return <Box>{props.children}</Box>;
}
